const toString = {}.toString;

export function isPlainObject(value: unknown) {
  return toString.call(value) === '[object Object]';
}
